
import React from 'react';
import PropTypes from 'prop-types';
import css from './styles/Blocking.module.scss';

export default function Blocking(props) {
    return (
        <>
            <div 
                className={`${css.blockOverlay} ${ (!props.show) ? css.hide : ''} ${props.overLayClassName}`} 
                style={props.overLayStyles}
            ></div>
            <div 
                className={`${css.msgContainer} ${ (!props.message || !props.show) ? css.hide : ''} ${props.messageClassName || ''}`} 
                style={props.messageStyles}
            >
                {(props.message) ? props.message : ''}
            </div>
        </>
    );
}
Blocking.defaultTypes = {
    messageStyles: {},
    messageClassName: '',
    overLayStyles: {},
    overLayClassName: ''
};
Blocking.propTypes = {
    show: PropTypes.bool,
    message: PropTypes.any,
    messageStyles: PropTypes.object,
    messageClassName: PropTypes.string,
    overLayStyles: PropTypes.object,
    overLayClassName: PropTypes.string
};
    
